module.exports = __webpack_public_path__ + "img/dealer.e9a67a86.png";